// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ah-4";
export var closeButton = "_ah-6";
export var dismissButton = "_ah-3";
export var editImageWithAiContainer = "_ah-8";
export var imageUploadWrapper = "_ah-7";
export var misspelledWord = "_ah-5";
export var spellCheckContainer = "_ah-2";
export var spin = "_ah-1";
export var spinning = "_ah-0";